import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {PIXI} from '@colonist/pixi'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Point} from '@colonist/game-mechanic-validators'

export class UIGameBarbarianHexView extends SpriteView {
    readonly barbarianProgressMarker: number

    constructor(barbarianProgressMarker: number, x: number, y: number, w: number, h: number, container: PIXI.Container) {
        const inactiveTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.barbarian_tracker_hex_inactive)
        super(x, y, w, h, container, inactiveTexture)
        this.barbarianProgressMarker = barbarianProgressMarker
    }

    setInactiveTexture() {
        const activeTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.barbarian_tracker_hex_inactive)
        this.texture = activeTexture
    }

    setActiveTexture() {
        const activeTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.barbarian_tracker_hex_active)
        this.texture = activeTexture
    }

    setAttackTexture() {
        const attackTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.barbarian_tracker_hex_attack)
        this.texture = attackTexture
    }

    getPointForBarbarianShip(): Point {
        const x = this.x
        const barbarianShipHeightAdjuster = 0.05
        const y = this.y - this.height * barbarianShipHeightAdjuster
        return new Point(x, y)
    }

    getPointForKnightSwords(): Point {
        const x = this.x + this.width
        const knightSwordsHeightAdjusted = 0.05
        const y = this.y - this.height * knightSwordsHeightAdjusted
        return new Point(x, y)
    }
}
